import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the STD treatment type.
 */
export const StdTreatment = new TreatmentType({
  id: '13',
  name: ConsultationTreatmentTypes.Std,
});
